<template>
  <div class="flex_row_center">
    <div class="main" style="margin-top:50px;">
      <b-container class="bv-example-row">
        <b-row>
          <b-col
            sm="12"
            md="4"
            v-for="(item, index) in tabData"
            :key="index"
          
          >
          <div   class="main-gard-item"
            :style="{ backgroundImage: 'url(' + item.bg + ')' }">
            <div class="main-gard-item-color"></div>
          <div class="main-gard-item-word">
            <div class="main-gard-item-title">{{ item.title }}</div>
            <div class="main-gard-item-dis">{{ item.dis }}</div>
          </div>
          </div>
        
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
var global = require("@/utils/global");

export default {
  name: "advantage",

  data() {
    return {
      tabData: [
        {
          title: "升职加薪",
          dis: "职称匹配职务晋升，提升行业和职场地位，升职加薪快人一步！",
          bg: global.pictureBaseUrl + "/advantage/升职加薪.jpg",
        },
        {
          title: "租房补贴",
          dis:
            "中级以上职称人才可申请公租房补贴，申请人才认定后也可享受800-2500租房补贴",
          bg: global.pictureBaseUrl + "/advantage/租房补贴.jpg",
        },
        {
          title: "高层次人才",
          dis:
            "取得职称可申请人才认定，享受购房补贴、优先摇号、子女就学等福利。",
          bg: global.pictureBaseUrl + "/advantage/高层次人才.jpg",
        },
        {
          title: "人才落户",
          dis:
            "杭州45周岁以内取得中级职称；50周岁以内取得高级职称即可申请人才落户。",
          bg: global.pictureBaseUrl + "/advantage/人才落户.jpg",
        },
        {
          title: "现金奖励",
          dis: "浙江省多地对于职称人才给与直接现金补贴，高达可得25万元！",
          bg: global.pictureBaseUrl + "/advantage/现金奖励.jpg",
        },
        {
          title: "退休金增发",
          dis: "取得高级职称退休后享受1150-1500元/月的退休金增发。",
          bg: global.pictureBaseUrl + "/advantage/退休金增发.jpg",
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-gard-item {
  position: relative;
  padding: 40px;
  color: rgb(255, 255, 255);
  font-size: 16px;
  line-height: 1.9;
  height: 250px;
  margin-bottom: 60px;
  background-size: 100% 100%;
}
.main-gard-item-color {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(40, 116, 228, 0.5);
  z-index: 1;
}
.main-gard-item-word {
  position: relative;
  z-index: 2;
}
.main-gard-item-title {
  font-weight: bold;
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/advantage.vue